/* global __ENV_STAYCAST_PAIRING_ENDPOINT__ */

/**
 * The endpoint to use when attempting to communicate with the pairing server.
 *
 * @constant
 *
 **/
// export const PAIRING_ENDPOINT = __ENV_STAYCAST_PAIRING_ENDPOINT__ || 'http://localhost:3000/';
export const PAIRING_ENDPOINT = 'https://cast-staging.sonifi.com';

/**
 * The amount of time to wait for a pairing attempt.
 *
 * @constant
 *
 **/
export const PAIRING_TIMEOUT = 1000 * 5;

/**
 * The length of a valid code.
 *
 * @constant
 *
 **/
export const CODE_LENGTH = 9;



// WEBPACK FOOTER //
// ./constants.js